(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/template/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/core/template/assets/javascripts/prescript.js'); 
var svs = svs || {};
svs.core = svs.core || {};
svs.core.template = svs.core.template || {};

 })(window);